import script from "./DeliveryView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeliveryView.vue?vue&type=script&setup=true&lang=ts"

import "./DeliveryView.vue?vue&type=style&index=0&id=cc4f67bc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc4f67bc"]])

export default __exports__